import React from "react";
import classNames from "../../classNames";

const noop = () => {};
const defaultProps = {
  type: "text",
  onChange: noop,
};

function InputText({
  className,
  onChange,
  strict,
  uppercase,
  label,
  maxLength,
  ...props
}) {
  const [focused, setFocused] = React.useState(false);
  const [charCount, setCharCount] = React.useState(
    (props.defaultValue || "").length
  );

  function onInput(e) {
    const value = e.target.value;
    const character = value.charAt(value.length - 1);
    // only string
    if (strict && !/^[a-zA-Z]*$/.test(character)) {
      return;
    }
    if (uppercase) {
      e.target.value = value.toUpperCase();
    }
    setCharCount(e.target.value.length);
    onChange(e.target.value);
  }

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {label && (
        <label
          style={{
            display: "block",
            fontSize: "0.75rem",
            fontWeight: 600,
            color: focused ? "#667eea" : "#64748b",
            marginBottom: "6px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            transition: "color 0.2s ease",
          }}
        >
          {label}
        </label>
      )}
      <textarea
        className={classNames("form-control", className)}
        onInput={onInput}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        maxLength={maxLength}
        {...props}
        style={{
          borderRadius: "10px",
          border: focused ? "2px solid #667eea" : "2px solid #e2e8f0",
          padding: "12px 14px",
          fontSize: "0.9rem",
          color: "#1e293b",
          backgroundColor: focused ? "#fafbff" : "#f8fafc",
          transition: "all 0.2s ease",
          boxShadow: focused
            ? "0 0 0 3px rgba(102,126,234,0.1)"
            : "none",
          outline: "none",
          resize: "vertical",
          minHeight: "80px",
          ...(props.style || {}),
        }}
      />
      {maxLength && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "4px",
            fontSize: "0.7rem",
            color: charCount >= maxLength ? "#ef4444" : "#94a3b8",
            transition: "color 0.2s ease",
          }}
        >
          {charCount}/{maxLength}
        </div>
      )}
    </div>
  );
}

InputText.defaultProps = defaultProps;

export default InputText;
